module.exports = __webpack_public_path__ + "static/media/website-hover.b22003d8.png";